import { Modal as AntModal, ModalProps as AntModalProps } from 'antd';
import cn from 'clsx';
import { XText } from 'components/UI/XText/XText';
import { FC, PropsWithChildren, ReactNode } from 'react';

import styles from './Modal.module.less';

export interface ModalProps extends AntModalProps {
  img?: ReactNode;
  title?: ReactNode;
}

export const Modal: FC<PropsWithChildren<ModalProps>> = ({
  img,
  title,
  className,
  children,
  okButtonProps,
  footer,
  ...props
}) => {
  return (
    <AntModal
      className={cn(styles.container, className, { [styles.isImg]: img })}
      cancelButtonProps={{ block: true, size: 'large' }}
      okButtonProps={{ block: true, size: 'large', ...okButtonProps }}
      footer={footer === false ? null : footer}
      {...props}
    >
      {img && <div className={styles.imgContainer}>{img}</div>}
      {title && (
        <div className={styles.title}>
          <XText variant="title-h1-s">{title}</XText>
        </div>
      )}
      {children}
    </AntModal>
  );
};
